import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventModel } from '@shared/models/event.model';

@Component({
  selector: 'app-event-list-item',
  templateUrl: './event-list-item.component.html',
  styleUrls: ['./event-list-item.component.scss'],
  standalone: false
})
export class EventListItemComponent {
  @Input() event: EventModel;
  @Input() mode: 'public' | 'mine' = 'public';

  @Output() register = new EventEmitter<EventModel>();
  @Output() unregister = new EventEmitter<EventModel>();

  onRegisterClick(event: EventModel): void {
    this.register.emit(event);
  }

  onUnregisterClick(event: EventModel): void {
    this.unregister.emit(event);
  }
}